import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MinhaConta } from '@/features/auth/componentes/MinhaConta';

const busca = z.object({
  aba: z.enum(['senha', '2fa', 'sessoes']).optional().catch(undefined),
});

export const Route = createFileRoute('/_autenticado/minha-conta')({
  staticData: { titulo: 'Minha conta' },
  validateSearch: busca,
  component: PaginaMinhaConta,
});

function PaginaMinhaConta() {
  const { aba } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MinhaConta
      aba={aba ?? 'senha'}
      aoMudarAba={(nova) => {
        void navigate({ search: { aba: nova }, replace: true });
      }}
    />
  );
}
